import { React, connect, fetchApi } from '@gasbuddy/react';
import { Dimmer, Loader, Segment, Button, Form, Divider, Message } from 'semantic-ui-react';
import { Role } from '../../roles';
import { Auth, Nav } from '../../components';

class BaseManageGasBackCodes extends React.Component {
  state = {}

  go = (e) => {
    e.preventDefault();
    const { count, amount, memo } = this.state;
    this.setState({ loading: true, outputs: null }, async () => {
      const { body, status } = await fetchApi({
        url: '/payments/gasback/create-codes',
        body: { count, amount, memo },
      });
      this.setState({
        loading: false,
        outputs: body?.codes,
        error: status === 200 ? null : JSON.stringify(body, null, '\t'),
      });
    });
  }

  render() {
    const { loading, outputs, error } = this.state;
    return (
      <Auth
        forRoles={[Role.CreateGasBackCodes, Role.Superuser]}
      >
        <Nav>
          <Dimmer.Dimmable as={Segment} dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <div>
              <h1>Create GasBack Codes</h1>
              <Form onSubmit={this.go}>
                {error
                  && (
                    <Message negative>
                      <Message.Content><pre>{error}</pre></Message.Content>
                    </Message>
                  )
                }
                <Form.Group inline>
                  <Form.Input
                    label="Create"
                    placeholder="# of codes"
                    type="number"
                    onChange={({ target: { value } }) => this.setState({ count: value })}
                  />
                  <Form.Input
                    type="number"
                    label="worth $"
                    labelPosition="left"
                    placeholder="0.00"
                    onChange={({ target: { value } }) => this.setState({ amount: value })}
                  />
                  <Form.Input
                    placeholder="Memo / Description"
                    onChange={({ target: { value } }) => this.setState({ memo: value })}
                  />
                  &nbsp;
                  <Button loading={loading}>Go</Button>
                </Form.Group>
                <Divider />
                <Form.Group widths="equal">
                  <Form.TextArea
                    rows={30}
                    readOnly
                    value={outputs?.join('\n')}
                    label="Results"
                    placeholder="Results will appear here"
                  />
                </Form.Group>
              </Form>
            </div>
          </Dimmer.Dimmable>
        </Nav>
      </Auth>
    );
  }
}

export const ManageGasBackCodes = connect(({ api }) => ({ api }))(BaseManageGasBackCodes);
